export const LOAD_METADATA = 'containers/MetadataProvider/LOAD_METADATA';
export const LOAD_METADATA_SUCCESS = 'containers/MetadataProvider/LOAD_METADATA_SUCCESS';
export const LOAD_METADATA_ERROR = 'containers/MetadataProvider/LOAD_METADATA_ERROR';
